var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "word-search-color-wrapper" },
    _vm._l(_setup.COLOR_CONFIGS, function (config) {
      return _c(_setup.ColorPropertyItem, {
        key: config.configKey,
        attrs: {
          label: config.label,
          "config-key": config.configKey,
          color: _setup.model[config.configKey],
          disabled: _setup.disabled,
          "highlight-stroke-enabled": _setup.model.highlightStrokeEnabled,
          "highlight-stroke-width": _setup.model.highlightStrokeWidth,
        },
        on: {
          "color-selected": (color) =>
            _setup.onColorSelected(config.configKey, color),
          "toggle-highlight-stroke": _setup.toggleHighlightStroke,
          "update-stroke-width": _setup.updateHighlightStrokeWidth,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }